import { render, staticRenderFns } from "./MarkdownSettingsFields.vue?vue&type=template&id=177a91b4&scoped=true&"
import script from "./MarkdownSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./MarkdownSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownSettingsFields.vue?vue&type=style&index=0&id=177a91b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a91b4",
  null
  
)

export default component.exports